export default __webpack_public_path__ + "static/media/puppyplay_screenshot.b63dbdd5.jpg";